import { render, staticRenderFns } from "./PlantVarietyAnnuityList.vue?vue&type=template&id=a19b0702&"
import script from "./PlantVarietyAnnuityList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyAnnuityList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyAnnuityList.vue?vue&type=style&index=0&id=a19b0702&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports